import { useUpdateCustomerMutation } from 'api/user-domain/user-domain';
import CustomersForm from 'components/forms/customers-form/customers-form.component';
import { useEditCustomersForm } from 'components/forms/customers-form/customers-form.hooks';
import { t } from 'i18next';
import FormDrawer from '../form-drawer/form-drawer.component';
import { useSnackbar } from 'notistack';

const EditCustomerDrawer = ({ open, close, drawerData }) => {
  const { enqueueSnackbar } = useSnackbar();
  const customerId = drawerData?.userId
    ? drawerData.userId
    : drawerData?.customerId;
  const {
    form,
    queryResult: { isFetching: getCustomerLoading, data: customerData },
  } = useEditCustomersForm(customerId);

  const [updateCustomerMutation, { isLoading: updateCustomerLoading }] =
    useUpdateCustomerMutation();

  const submit = async data => {
    try {
      await updateCustomerMutation({
        userId: customerId,
        body: {
          ...data,
          dateOfBirth: !!data.dateOfBirth ? `1900-${data.dateOfBirth}` : null,
        },
      }).unwrap();
      if (data.email !== customerData?.email) {
        enqueueSnackbar(
          t('page.customers.form.customer.emailUpdate.verificationInfo'),
          { severity: 'info' },
        );
      }
      close();
      form.reset();
    } catch (_e) {}
  };

  const cancel = () => {
    close();
    form.reset();
  };

  return (
    <FormDrawer
      title={t('page.customers.card.editCustomer')}
      submitButtonLabel={t('page.customers.card.saveCustomer')}
      data-testid="CustomerDrawer.Drawer"
      open={open}
      onClose={cancel}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      isLoading={updateCustomerLoading || getCustomerLoading}
    >
      <CustomersForm data={customerData} />
    </FormDrawer>
  );
};

export default EditCustomerDrawer;
